import React, { useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import styles from './PartyEvents.module.css';
import { resetButtons, setBackButtonVisible, setPromptOkCancelOnBack, setReloadButtonVisible, setSavePartyEventVisible } from '../menu/menuSlice'
import { selectCurrentPartyEventTitle, selectCurrentPartyEventLocation, setEventTitle, setEventLocation, selectCurrentPartyEvent, setStartDate, setEndDate, setLogoutRequested } from '../currentPartyEvent/currentPartyEventSlice'
import { Page } from '../../Page';
import { addPartyEventAsync, selectPartyEventsStatus } from './partyEventsSlice'
import { MessageBoxAction, setMessage, setMessageBoxAction } from '../messageBoxes/messageBoxSlice';
import { useNavigate } from 'react-router-dom';
import { sanitizeEmail } from '../../utils/emailUtils';
import { DateTimePicker } from '../../components/DateTimePicker';
import { BackButton } from '../menu/BackButton';
import { DropDownButton } from '../../components/DropDownButton';
import { Browser } from '@capacitor/browser';
import { callbackUri } from '../../AppSettings';
import userImg from '../../images/user.svg';



export function EditPartyEvent() {
    const dispatch = useAppDispatch()
    const eventTitle = useAppSelector(selectCurrentPartyEventTitle)
    const eventLocation = useAppSelector(selectCurrentPartyEventLocation)
    const { isAuthenticated, getAccessTokenSilently, user, logout } = useAuth0()
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    const partyEventsStatus = useAppSelector(selectPartyEventsStatus)
    const navigate = useNavigate()
    
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setSavePartyEventVisible(true))
        dispatch(setPromptOkCancelOnBack(true))
        dispatch(setReloadButtonVisible(true))
        dispatch(setMessage('Are you sure you want to cancel saving this party?'))
    }, [dispatch])

        const doLogout = async () => {
        dispatch(setLogoutRequested(true))
        await logout({
          async openUrl(url) {
            await Browser.open({
              url,
              windowName: "_self",
            });
          },
          logoutParams: {
            returnTo: callbackUri
          }
        });
      };

    return (
        <Page>
            <div className={styles.controlbanner}>
                <div>
                <h4>{currentPartyEvent?.title}</h4>
                </div>
                <div className={styles.buttoncontainer}>
                <DropDownButton imgSrc={userImg} imgAlt="User Menu">
                <div className={styles.linkButton} onClick={doLogout}>Sign out</div>
                <div className={styles.linkButton} onClick={()=> {navigate('/Merchandise')}}>Merchandise</div>
                <div className={styles.linkButton} onClick={() => {navigate('/AccountDetails')}}>Account details</div>
                </DropDownButton>
                </div>
            </div>
            <div className={styles.bannerContainer}>
                <div>
                <h2>PartyPlanner.</h2>
                <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
            <div className={styles.currentEventInfoPanel}>
                <h2>Edit your event details:</h2>
            </div>
            <label className={styles.label} htmlFor='txtEventTitle'>Title:</label>
            <input
                id='txtEventTitle'
                className={styles.textbox}
                aria-label="Set Event Title"
                value={eventTitle}
                onChange={(e) => {
                    dispatch(setEventTitle(e.target.value))
                }}
                    />
            <label className={styles.label} htmlFor='txtEventLocation'>Location:</label>
            <input
                id='txtEventLocation'
                className={styles.textbox}
                aria-label="Set Location"
                value={eventLocation}
                onChange={(e) => dispatch(setEventLocation(e.target.value))}
                />

            <h3>Start</h3>
            <DateTimePicker nullDescription="Toggle if start date isn't relevant" transmissionDateTime={currentPartyEvent?.start} dateDescription='' timeDescription='' dateLabel='Date' timeLabel = 'Time'
                onDateChange={(e) => {
                    dispatch(setStartDate(e ?? ''))
                }}
            />
                
            <h3>End</h3>
            <DateTimePicker nullDescription="Toggle if end date isn't relevant" transmissionDateTime={currentPartyEvent?.end} dateDescription='' timeDescription='' dateLabel='Date' timeLabel = 'Time'
                onDateChange={(e) => {
                    dispatch(setEndDate(e ?? ''))
                }}
            />
            <br></br>
            <div className={styles.CancelSaveButtons}>
            <button className={styles.cancelButton} onClick={()=> {
                let msg2 = `Are you sure you want to cancel creating this party?`
                dispatch(setMessage(msg2))
                dispatch(setMessageBoxAction(MessageBoxAction.GoBack))
                navigate('/MessageBox')
            }}>Cancel</button>

            <button className={styles.EventSave} onClick={async () => {
                            if (currentPartyEvent != null) {
                                if (!currentPartyEvent.title) {
                                    alert('Title not set')
                                    return
                                }
                            if (!currentPartyEvent.location) {
                                alert('Location not set')
                                return
                            }
                            if (isAuthenticated && user?.email) { 
                                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                                }})
                                    dispatch(addPartyEventAsync( { 
                                        partyEvent: currentPartyEvent,
                                        token: accessToken,
                                        userEmail: sanitizeEmail(user?.email)
                                        }))
                                    if (partyEventsStatus === 'idle') {
                                        navigate(-1)
                                    } else {
                                        alert (`Not expected status '${ partyEventsStatus }'`)
                                    }
                            }
                        }    
                    }}>
                        Save
                    </button>
                    </div>
        <br></br>
        <br></br>
        <br></br>
    </Page>
    )
}